import { useEffect, useState } from 'react';
import { MAP_TILE_ERROR_DURATION_DISPLAY } from '@/constants';
import { useMobileViewDetect } from '../useMobileViewDetect/useMobileViewDetect';
import { usePageLayoutContext } from '../usePageLayoutContext/usePageLayoutContext';
/**
 * Hook to manage the map tile errors state
 *
 * @param map - Mapbox instance
 * @returns Object with tile error state and callbacks
 */
export const useMapTileError = (map) => {
    const { sidebarOpen, pricePageProps: { pricePageContext }, } = usePageLayoutContext();
    const { isMobileView } = useMobileViewDetect();
    const [hasError, setHasError] = useState(false);
    const [canBeDisplayedOnMobile, setCanBeDisplayedOnMobile] = useState(true);
    useEffect(() => {
        setHasError(false);
    }, [pricePageContext]);
    useEffect(() => {
        map?.on('error', (error) => {
            if (error?.errorType === 'TilesUnavailable') {
                setHasError(true);
            }
        });
    }, [map]);
    useEffect(() => {
        setCanBeDisplayedOnMobile(!sidebarOpen || !isMobileView);
        if (!hasError) {
            return;
        }
        const duration = setTimeout(() => {
            setHasError(false);
        }, MAP_TILE_ERROR_DURATION_DISPLAY);
        return () => clearTimeout(duration);
    }, [hasError, sidebarOpen, isMobileView]);
    return {
        hasError,
        canBeDisplayedOnMobile,
        setCanBeDisplayedOnMobile,
        setHasError,
    };
};
